/**
 * TierRoute — a <Route> that requires a capability.
 *
 * Guards a route at the point of navigation (deep links included):
 *   - not logged in       -> redirect to /login (preserving where they were headed)
 *   - logged in, no cap   -> render an inline notice telling them what unlocks it
 *   - allowed             -> render the route as normal
 *
 * This is UX; the server still enforces on every mutation.
 */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { UserAccessContext } from './UserAccessProvider';
import { hintFor } from '../utility/permissions';

const DeniedNotice = ({ capability, history }) => (
    <div style={{
        maxWidth: 480,
        margin: '10vh auto',
        textAlign: 'center',
        padding: '2em',
        fontFamily: 'Arial, sans-serif',
        color: '#4F4F4F',
    }}>
        <h2 style={{ fontSize: 18, fontWeight: 'bold' }}>You don't have access to this yet</h2>
        <p style={{ fontSize: 14, color: '#828282' }}>{hintFor(capability)}</p>
        <button
            onClick={() => history.push('/')}
            style={{
                marginTop: '1.5em',
                background: '#FDAF2A',
                color: 'white',
                fontWeight: 'bold',
                border: 'none',
                borderRadius: 6,
                padding: '10px 24px',
                cursor: 'pointer',
            }}
        >
            Back to Dashboard
        </button>
    </div>
);

export const TierRoute = ({ component: Component, render, capability, ...rest }) => (
    <Route
        {...rest}
        render={(props) => (
            <UserAccessContext.Consumer>
                {(access) => {
                    if (!access.ready) {
                        return <div style={{ padding: '2em', textAlign: 'center' }}>Checking access…</div>;
                    }
                    if (!access.isLoggedIn) {
                        return (
                            <Redirect
                                to={{
                                    pathname: '/login',
                                    state: { redirectProps: props.location.pathname },
                                }}
                            />
                        );
                    }
                    if (!access.can(capability)) {
                        return <DeniedNotice capability={capability} history={props.history} />;
                    }
                    return Component ? <Component {...props} /> : render(props);
                }}
            </UserAccessContext.Consumer>
        )}
    />
);

export default TierRoute;
